// Safe synchronous browser storage facade. Native targets continue to use
// Capacitor storage/database layers; Chrome gets a resilient localStorage/
// sessionStorage wrapper that tolerates privacy mode, blocked storage and
// quota failures without crashing the application.
const memoryLocal = new Map();
const memorySession = new Map();

function makeSafeStorage(kind, memory) {
  const getBackend = () => {
    try {
      if (typeof window === 'undefined') return null;
      return kind === 'session' ? window.sessionStorage : window.localStorage;
    } catch {
      return null;
    }
  };
  return {
    getItem(key) {
      const backend = getBackend();
      try { return backend ? backend.getItem(key) : (memory.has(key) ? memory.get(key) : null); } catch { return memory.has(key) ? memory.get(key) : null; }
    },
    setItem(key, value) {
      const stringValue = String(value);
      const backend = getBackend();
      try { if (backend) { backend.setItem(key, stringValue); return; } } catch { /* fall through */ }
      memory.set(key, stringValue);
    },
    removeItem(key) {
      const backend = getBackend();
      try { backend?.removeItem(key); } catch { /* fall through */ }
      memory.delete(key);
    },
    clear() {
      const backend = getBackend();
      try { backend?.clear(); } catch { /* fall through */ }
      memory.clear();
    },
    key(index) {
      const backend = getBackend();
      try { return backend?.key(index) ?? Array.from(memory.keys())[index] ?? null; } catch { return Array.from(memory.keys())[index] ?? null; }
    },
    get length() {
      const backend = getBackend();
      try { return backend ? backend.length : memory.size; } catch { return memory.size; }
    },
  };
}

export const safeLocalStorage = makeSafeStorage('local', memoryLocal);
export const safeSessionStorage = makeSafeStorage('session', memorySession);

export function storageAvailable(storage = safeLocalStorage) {
  const key = '__drilllog_storage_test__';
  try {
    storage.setItem(key, '1');
    storage.removeItem(key);
    return true;
  } catch { return false; }
}
